import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import Plx from "react-plx";
import { Container, Grid, Paper, Typography } from "@material-ui/core";

import jardins from "./Clients/jardins.PNG";
import hidroponia from "./Clients/hidroponia.PNG";
import estufa from "./Clients/estufa.PNG";
import vinha from "./Clients/vinha.PNG";

import useWindowDimensions from "../../../common/hooks/useWindowDimensions";

import {
  styles,
  item01Anim,
  item02Anim,
  item03Anim,
  item04Anim,
} from "./Clients.styles";

function Clients({ classes, screen }) {
  const { height: viewHeight } = useWindowDimensions();

  console.log("screen: %o", screen);
  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Plx
            className={classes.paperItemPlx}
            parallaxData={item01Anim({ viewHeight, screen })}
          >
            <Paper className={classes.paperItem}>
              <Grid
                spacing={3}
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <img src={jardins} className={classes.img} alt="alt" />
                </Grid>
                <Grid container direction="column" item xs={8}>
                  <Typography component="h3" variant="h3" className={classes.description}>
                    <b>Jardins</b>
                  </Typography>
                  <Typography component="p" className={classes.description}>
                    <b>Rega eficiente</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Grid>
              </Grid>
            </Paper>
          </Plx>
        </Grid>
        <Grid item xs={6}>
          <Plx
            className={classes.paperItemPlx}
            parallaxData={item02Anim({ viewHeight, screen })}
          >
            <Paper className={classes.paperItem}>
              <Grid
                spacing={3}
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <img src={hidroponia} className={classes.img}  alt="alt"/>
                </Grid>
                <Grid container direction="column" item xs={8}>
                  <Typography component="h3" variant="h3" className={classes.description}>
                    <b>Hidroponia</b>
                  </Typography>
                  <Typography component="p" className={classes.description}>
                    <b>Nutrientes e qualidade da água</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Grid>
              </Grid>
            </Paper>
          </Plx>
        </Grid><Grid item xs={6}>
          <Plx
            className={classes.paperItemPlx}
            parallaxData={item03Anim({ viewHeight, screen })}
          >
            <Paper className={classes.paperItem}>
              <Grid
                spacing={3}
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <img src={estufa} className={classes.img}  alt="alt"/>
                </Grid>
                <Grid container direction="column" item xs={8}>
                  <Typography component="h3" variant="h3" className={classes.description}>
                    <b>Estufas</b>
                  </Typography>
                  <Typography component="p" className={classes.description}>
                    <b>Climatização e qualidade do solo</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Grid>
              </Grid>
            </Paper>
          </Plx>
        </Grid><Grid item xs={6}>
          <Plx
            className={classes.paperItemPlx}
            parallaxData={item04Anim({ viewHeight, screen })}
          >
            <Paper className={classes.paperItem}>
              <Grid
                spacing={3}
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <img src={vinha} className={classes.img}  alt="alt"/>
                </Grid>
                <Grid container direction="column" item xs={8}>
                  <Typography component="h3" variant="h3" className={classes.description}>
                    <b>Produção</b>
                  </Typography>
                  <Typography component="p" className={classes.description}>
                    <b>Analise de microclimas</b>
                  </Typography>
                  <p>
                    Donec laoreet eos eu. Potenti, rem, euismod diam quisquam
                    purus labore, hendrerit ullamco, cursus condimentum!
                  </p>
                </Grid>
              </Grid>
            </Paper>
          </Plx>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withStyles(styles)(Clients);
